import React from 'react';
import { PricingBox } from './PricingBox';

export const PricingSection = () => {
  return (
    <section className="bg-jp-section border-t border-jp-line px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
      <div className="max-w-7xl mx-auto">
        <PricingBox />
      </div>
    </section>
  );
};

export default PricingSection;
